import React from 'react';
import { usePaginatedQuery } from 'react-query';

import { useRedirectForbidden } from '@hooks';

import * as utils from './utils';

export default (queryKey, queryFn, { parseApiError = utils.parseApiError, ...queryOptions }) => {
  const [error, setError] = React.useState(null);
  const redirectForbidden = useRedirectForbidden();

  const queryResult = usePaginatedQuery(queryKey, queryFn, {
    ...queryOptions,
    onError: async (e, ...args) => {
      if (e.response?.status === 403) redirectForbidden();

      const parsedError = await parseApiError({ error: e });
      setError(parsedError);
      // eslint-disable-next-line no-unused-expressions
      return queryOptions.onError?.(parsedError, ...args);
    },
    onSuccess: (...args) => {
      setError(null);
      // eslint-disable-next-line no-unused-expressions
      return queryOptions.onSuccess?.(...args);
    },
  });

  return {
    ...queryResult,
    error,
  };
};
